import React from 'react';
import { motion } from 'framer-motion';
import { Slide, SlideHeader, itemVariants } from '../Slide';
export function SlideHowItWorks() {
  const steps = [{
    n: '01',
    title: 'Ingest',
    body: 'Connect every signal across the engineering lifecycle. Commits, PRs, Jira tickets, CI/CD runs, and raw token usage from AI providers.',
    items: ['GitHub / GitLab / Bitbucket', 'Jira / Linear', 'OpenAI / Anthropic APIs']
  }, {
    n: '02',
    title: 'Measure',
    body: 'Correlate AI activity with engineering output. Track adoption rates, measure impact on cycle time, and calculate exact ROI per developer.',
    items: ['Cycle Time Reduction', 'AI Code Acceptance Rate', 'Cost per PR']
  }, {
    n: '03',
    title: 'Learn',
    body: 'The RL loop sharpens every agent. As teams act on insights, the Waydev brain learns which patterns actually improve engineering velocity.',
    items: ['Automated Bottleneck Detection', 'Context Injection for Agents', 'Predictive Resource Allocation']
  }];
  return <Slide data-id="element-127">
      <SlideHeader data-id="element-128">How It Works</SlideHeader>

      <div className="flex-1 flex flex-col justify-center" data-id="element-129">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10 lg:gap-16" data-id="element-130">
          {steps.map(step => <motion.div key={step.n} variants={itemVariants} className="relative" data-id="element-131">
              <div className="text-6xl md:text-7xl font-serif font-light text-gray-500 mb-6 leading-none tracking-tight" data-id="element-132">
                {step.n}
              </div>
              <h3 className="text-3xl font-serif mb-6 pt-4 border-t border-white" data-id="element-133">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed mb-6" data-id="element-134">{step.body}</p>
              <ul className="space-y-2 text-sm font-mono text-gray-500" data-id="element-135">
                {step.items.map(item => <li key={item} data-id="element-136">→ {item}</li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </Slide>;
}